import React from 'react';
import DropdownWithLabel from '@/components/ui/DropdownWithLabel';
import type { Section } from '@/types/section.types';
import { useGetSectionsQuery } from "@/components/features/sections/services/section.queries";

interface SectionDropdownProps {
    label?: string;
    value?: string;
    onChange?: (value: string) => void;
    error?: string;
    required?: boolean;
    disabled?: boolean;
    placeholder?: string;
    helperText?: string;
}

const SectionDropdown = React.forwardRef<HTMLSelectElement, SectionDropdownProps>(
    ({
         label = 'Ενότητα',
         value,
         onChange,
         error,
         required = false,
         disabled = false,
         placeholder = 'Επιλέξτε ενότητα',
         helperText,
         ...props
     }, ref) => {
        const { data: sections, isLoading, isError } = useGetSectionsQuery();

        const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
            onChange?.(event.target.value);
        };

        const sectionOptions = React.useMemo(() => {
            if (!sections) return [];

            return sections.map((section: Section) => ({
                value: section.section_id,
                label: section.section_name,
            }));
        }, [sections]);

        if (isError) {
            return (
                <DropdownWithLabel
                    ref={ref}
                    label={label}
                    value={value}
                    onChange={handleChange}
                    options={[]}
                    error="Αποτυχία φόρτωσης ενοτήτων"
                    required={required}
                    disabled={true}
                    placeholder={placeholder}
                    helperText={helperText}
                    {...props}
                />
            );
        }

        return (
            <DropdownWithLabel
                ref={ref}
                label={label}
                value={value}
                onChange={handleChange}
                options={sectionOptions}
                error={error}
                required={required}
                disabled={disabled || isLoading}
                placeholder={isLoading ? 'Φόρτωση...' : placeholder}
                helperText={helperText}
                {...props}
            />
        );
    }
);

SectionDropdown.displayName = 'SectionDropdown';

export default SectionDropdown;
